import { TIPTAP_ACTION_BUTTON_TYPE, TIPTAP_LINK_BUTTON_TYPE } from './../../ricos-content';
import { createRicosNodeExtension } from './../../plugin-commons';

import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from '../types';
import { Button as Component } from './component';

const getButtonExtension = (name: string, disableResize: boolean) => [
  createRicosNodeExtension({
    groups: ['custom-styles', 'not-overtypable'],
    type: 'react-node',
    reconfigure: (config, _extensions, props, settings) => {
      return {
        ...config,
        disableResize,
        isTextWrap: props.isTextWrap ?? true,
        addOptions: () => settings,
      };
    },
    Component,
    name,
    createExtensionConfig() {
      return {
        name: this.name,
        group: 'block layoutCellContent collapsibleListItemBodyContent tableCellContent',
        selectable: true,
        draggable: true,
        addAttributes: () => ({
          type: null,
          containerData: null,
          styles: null,
          text: null,
          link: null,
        }),
      };
    },
  }),
];

export const tiptapExtensionsMap = ({ disableResize }: { disableResize: boolean }) => ({
  [LINK_BUTTON_TYPE]: getButtonExtension(TIPTAP_LINK_BUTTON_TYPE, disableResize),
  [ACTION_BUTTON_TYPE]: getButtonExtension(TIPTAP_ACTION_BUTTON_TYPE, disableResize),
});
